import { ProgramDetailLayout } from '@layouts/membership/ProgramDetailLayout'
import BalanceAndCreditsTab from '@pages/settings/membership/programs/BalanceAndCreditsTab'
import ConciergeTab from '@pages/settings/membership/programs/ConciergeTab'
import DesignBrandingTab from '@pages/settings/membership/programs/DesignBrandingTab'
import EmailNotificationTab from '@pages/settings/membership/programs/EmailNotificationTab'
import FormQuestionsTab from '@pages/settings/membership/programs/FormQuestionsTab'
import InformationsTab from '@pages/settings/membership/programs/InformationsTab'
import PaymentSettingsTab from '@pages/settings/membership/programs/PaymentSettingsTab'
import WalletCardTab from '@pages/settings/membership/programs/WalletCardTab'
import { Navigate, RouteObject } from 'react-router-dom'

const programDetailRoutes: RouteObject[] = [
  {
    element: <ProgramDetailLayout />,
    children: [
      { path: 'informations', element: <InformationsTab /> },
      { path: 'concierge', element: <ConciergeTab /> },
      { path: 'design-branding', element: <DesignBrandingTab /> },
      { path: 'wallet-card', element: <WalletCardTab /> },
      { path: 'form-questions', element: <FormQuestionsTab /> },
      { path: 'email-notifications', element: <EmailNotificationTab /> },
      { path: 'payment-settings', element: <PaymentSettingsTab /> },
      { path: 'balance-and-credits', element: <BalanceAndCreditsTab /> },
      { index: true, element: <Navigate to="informations" replace /> },
      { path: '*', element: <Navigate to="/404" replace /> },
    ],
  },
]

export default programDetailRoutes
